export default __webpack_public_path__ + "static/media/border.9d409dbf.svg";